import { render, staticRenderFns } from "./BerkasLampiran.vue?vue&type=template&id=305412ba&scoped=true"
import script from "./BerkasLampiran.vue?vue&type=script&lang=js"
export * from "./BerkasLampiran.vue?vue&type=script&lang=js"
import style0 from "./BerkasLampiran.vue?vue&type=style&index=0&id=305412ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305412ba",
  null
  
)

export default component.exports